import { Map } from "immutable"

const INIT_STATE = Map({})

const translationDataReducer = (state = INIT_STATE, action) => state

export default translationDataReducer